/**
 * Validation du tableau de formulaire
 * @param {*} forms
 * @parma Boolean disabled
 * @returns
 */
function validate(forms, disabled = true) {
    this.validation.disabled = disabled;
    const validates = forms.map(f => f.validate());
    if (!this.modal) {
        this.$nextTick(() => {
            const firstError = forms[0].$el.querySelector(".v-text-field.error--text") || forms[0].$el.querySelector(".v-messages.error--text")
            if (firstError) {
                this.$vuetify.goTo(firstError, { offset: 100 });
            }
        });
    }
    return validates.every(v => !!v);
}

function clearValidation() {
    this.validation.fields = {};
    this.validation.globals = [];
}

/**
 * Suppression partielle des validations
 */
function nettoyeValidation(predicate) {
    const fields = this.validation.fields;
    for (const k of Object.keys(fields)) {
        if (predicate(k)) {
            this.$delete(fields, k);
        }
    }
    this.validation.globals = [];
}

export default function makeValidation(options = {}) {
    const { provide = true } = options;
    const out = {
        data() {
            return {
                validation: {
                    disabled: true,
                    fields: {},
                    globals: [],
                }
            }
        },
        methods: {
            validate,
            clearValidation,
            nettoyeValidation,

            /**
             * Enregistrement d'une erreur distante
             * @param {*} axiosError
             * @param {*} forms
             * @returns
             */
            async remoteError(axiosError, forms) {
                var erreurs = axiosError.response?.data || {};
                const validation = this.validation;

                if (erreurs instanceof Blob) {
                    //si l'on a un blob on le décode
                    erreurs = JSON.parse(await erreurs.text());
                }

                const fields = {};
                validation.fields = fields;
                (erreurs.fieldErrors || []).forEach(item => {
                    const k = item.field;
                    fields[k] = fields[k] || [];
                    fields[k].push(item);
                });

                validation.globals.splice(
                    0,
                    validation.globals.length,
                    ...(erreurs.globalErrors || [])
                );
                //relance la validation pour faire apparaitre les erreurs du serveur
                return this.validate(forms, false);
            },
        }
    };

    if (provide) {
        out.provide = function () {
            return {
                validation: this.validation
            };
        };
    }

    return out;
}
